import request from '@/utils/request'
import host from '@/api/base/host'
import { AsyncRequest } from '@/utils/request'
const apiUrl = host.path('dev', { module: 'activity', dev: 'v1/order' })

export default {
  getOrderList(data) {
    return AsyncRequest({
      loading: true,
      request: () =>
        request({
          url: apiUrl('getOrderByUserId'),
          method: 'post',
          data
        })
    })
  }
}
